import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { ITenantMemberUser } from 'src/interfaces/TenantMember';
import { getTenantUsers } from 'src/services/TenantsService';

export const useGetTenantUsers = (
	searchText?: string,
	pageSize?: number,
	active?: boolean
): UseQueryResult<ITenantMemberUser[]> => {
	return useQuery({
		queryKey: ['tenantUsers', searchText, pageSize, active],
		queryFn: () => getTenantUsers(searchText, pageSize, active)
	});
};
